import React, { useState } from 'react';
import { api, BACKEND_URL } from '../utils/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Loader2, Upload, X } from 'lucide-react';
import { toast } from 'sonner';

const ImageUpload = ({ value, onChange, placeholder = "Upload Image" }) => {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const response = await api.upload(file);
      // Construct full URL if it's a relative path from our backend
      const url = response.data.url.startsWith('http') 
        ? response.data.url 
        : `${BACKEND_URL}${response.data.url}`;
      
      onChange(url);
      toast.success('Imagem enviada com sucesso!');
    } catch (error) {
      console.error('Upload failed:', error);
      toast.error('Erro ao enviar imagem');
    } finally {
      setUploading(false);
    }
  };

  const handleClear = () => {
    onChange('');
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 font-mono"
        />
        <div className="relative">
          <input
            type="file"
            id={`file-upload-${placeholder.replace(/\s+/g, '-').toLowerCase()}`}
            className="hidden"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
          />
          <Button 
            asChild 
            variant="outline" 
            className="cursor-pointer bg-secondary hover:bg-secondary/80"
            disabled={uploading}
            type="button"
          >
            <label htmlFor={`file-upload-${placeholder.replace(/\s+/g, '-').toLowerCase()}`}>
              {uploading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Upload className="h-4 w-4" />
              )}
            </label>
          </Button>
        </div>
        {value && (
          <Button 
            variant="ghost" 
            size="icon"
            onClick={handleClear}
            className="text-destructive hover:bg-destructive/10"
            type="button"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
      
      {value && (
        <div className="mt-2 p-2 border border-border rounded-md bg-secondary/20 inline-block h-36 w-full flex items-center justify-center">
          <img 
            src={value} 
            alt="Preview" 
            className="h-full w-full object-contain rounded-sm"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/150?text=Error';
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
